export default __webpack_public_path__ + "static/media/dataEngineering_cardImg.b700d31f.jpg";